"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

interface Breadcrumb {
  label: string;
  href: string;
}

export default function Breadcrumbs() {
  const pathname = usePathname();
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);

  useEffect(() => {
    if (!pathname) return;

    const pathSegments = pathname.split("/").filter(Boolean);
    const breadcrumbList: Breadcrumb[] = [];

    const fetchDynamicTitle = async (segment: string, index: number) => {
      const href = "/" + pathSegments.slice(0, index + 1).join("/");
      if (pathSegments[0] === "consultations" && index === 1) {
        // Fetch the consultation title for the [id] segment
        if (segment === "new") {
          breadcrumbList.push({ label: "New Consultation", href });
          return;
        }
        try {
          const res = await fetch(`/api/consultations/${segment}`);
          if (res.ok) {
            const data = await res.json();
            breadcrumbList.push({ label: data.consultation.title, href });
          } else {
            breadcrumbList.push({ label: "New Consultation", href });
          }
        } catch {
          breadcrumbList.push({ label: "New Consultation", href });
        }
      } else if (pathSegments[0] === "scenarios" && index === 1) {
        // Fetch the scenario title for the [id] segment
        if (segment === "new") {
          breadcrumbList.push({ label: "New Scenario", href });
          return;
        }
        try {
          const res = await fetch(`/api/scenarios/${segment}`);
          if (res.ok) {
            const data = await res.json();
            breadcrumbList.push({ label: data.title, href });
          } else {
            breadcrumbList.push({ label: "New Scenario", href });
          }
        } catch {
          breadcrumbList.push({ label: "New Scenario", href });
        }
      } else {
        // Format other segments
        let formattedSegment =
          segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
        formattedSegment = formattedSegment.replace(/-/g, " ");
        breadcrumbList.push({ label: decodeURIComponent(formattedSegment), href });
      }
    };

    (async () => {
      for (let i = 0; i < pathSegments.length; i++) {
        await fetchDynamicTitle(pathSegments[i], i);
      }
      setBreadcrumbs(breadcrumbList);
    })();
  }, [pathname]);

  return (
    <div className="breadcrumbs text-sm">
      <ul>
        {pathname === "/" ? null : (
          <li>
            <Link href="/">Home</Link>
          </li>
        )}
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={index}>
            <Link href={breadcrumb.href}>{breadcrumb.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}